import { Reveal } from "@/components/Reveal";

const chapters = [
  {
    n: "01",
    title: "Flavour first",
    body: "Every artist has a flavour — a sound, a palette, a way of walking into a room. We don't invent it. We distill it until it's unmistakable, then build the entire brand around that single scoop of truth.",
  },
  {
    n: "02",
    title: "Melting is allowed",
    body: "Brands that never drip are brands nobody tastes. We prototype loudly, break our own layouts, and let the work stay human. Controlled chaos is a strategy, not an accident.",
  },
  {
    n: "03",
    title: "The cherry on top",
    body: "The last 5% is the whole product. The emboss on the vinyl, the easing curve on the site, the caption voice at 2am. We obsess over the details fans never notice — and always feel.",
  },
];

export const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto-section" className="relative waffle-grid py-28 md:py-44">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <Reveal>
        <p className="text-[11px] font-semibold uppercase tracking-[0.35em] text-[#2D1A13]/50 mb-6">
          The Manifesto
        </p>
        <h2 className="font-serif-display font-bold tracking-tighter text-4xl md:text-6xl leading-tight max-w-3xl">
          Three rules we never
          <span className="italic text-[#FF8E9E]"> let melt.</span>
        </h2>
      </Reveal>

      <div className="mt-24 md:mt-36 flex flex-col gap-28 md:gap-40">
        {chapters.map((c, i) => (
          <Reveal key={c.n} delay={0.05} className={`relative grid md:grid-cols-12 gap-8 items-start ${i % 2 === 1 ? "" : ""}`}>
            <span
              data-testid={`manifesto-number-${c.n}`}
              className="font-serif-display italic font-black text-[26vw] md:text-[13rem] leading-none text-[#FF8E9E]/35 md:col-span-4 md:-mt-10 select-none"
            >
              {c.n}
            </span>
            <div className={`md:col-span-6 ${i % 2 === 1 ? "md:col-start-7" : "md:col-start-6"} md:pt-10`}>
              <h3 className="font-serif-display font-bold text-3xl md:text-5xl tracking-tight mb-6">{c.title}</h3>
              <p className="text-base md:text-lg font-light leading-relaxed text-[#2D1A13]/75 max-w-xl">{c.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
